import { pageRoutes } from "../Routing/pageRoutes";
import { Switch, Tag, Spin, Popover, Button, Empty } from 'antd';
import {
  trash, profile, edit, pepsi, pepsi3, pepsi2, alert,
  ContainerOutlined, DesktopOutlined, PieChartOutlined,
  LoadingOutlined, UserOutlined, history
} from "../Utils/imports"
import CustomUserTable from "../Components/Table/CustomUserTable";
import PlantSettingsAlert from "../Components/PlantSettings-Alert/PlantSettingsAlert";
import PlantSiteChampion from "../Components/PlantSiteChampion/PlantSiteChampion";
import PlantsettingRole from "../Pages/PlantSettings/plantsettingRole";
import { azureFunctionsURL } from "../Environments/environment"
import Timer from "../Components/Timer/Timer";
import moment from "moment";
import { dashboardic, lineopic, integration, plantsetting, lineBoard, trenddown, tasksquare, setting, documenttext, linesetting, homepage } from "../Utils/imports"
import NoDataFound from "../Components/Helpers/NoDataFound";
import AuditTrailTableDes from "../Components/OEE/AuditTrail/AuditTrailTableDes";
import LineInformation from "../Components/Line Settings/LineInformation/LineInformation"
import LineSettingsShift from "../Components/Line Settings/LineSettings-Shift/LineSettingsShift";
import LineSettingsProduct from "../Components/Line Settings/LineSettings-Product/LineSettingsProduct";
import PlannedDowntime from "../Components/Line Settings/Planned Downtime/PlannedDowntime";
import Downtime from "../Components/Line Settings/Downtime/Downtime";
import ManualEntry from "../Components/Line Settings/Manual Entry/ManualEntry";
import FormulaCreation from "../Components/Line Settings/Formula Creation/FormulaCreation";
import WeeklyTargets from "../Components/Line Settings/Weekly Targets/WeeklyTargets";
import WeeklySchedule from "../Components/Line Settings/Weekly Schedule/WeeklySchedule";
import DailyTargets from "../Components/Line Settings/Daily Targets/DailyTargets";

export const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

export const HeaderSelectTitle = {
  plant: {
    text: "Select Plant",
  },
  machine: {
    text: "Select Machine",
  },
  hall: {
    text: "Select Hall",
  },
  line: {
    text: "Select Line",
  },
};

export const selectOptions = [
  {
    value: 0,
    label: "Pepsi",
  },
  {
    value: 1,
    label: "PepsiCo",
  },
  {
    value: 2,
    label: "Coke",
  },
  {
    value: 3,
    label: "Mirinda",
  },
  {
    value: 4,
    label: "7UP",
  },
];

export const handleSelect = (value) => {
  console.log({ value });
};

export const aggregatedGraphs = [
  {
    head: "Aggregated Efficiency",
  },
  {
    text: "Blow Mind",
    percent: 90,
  },
  {
    text: "Labeller",
    percent: 80,
  },
  {
    text: "Variopac",
    percent: 70,
  },
  {
    text: "Palletizer",
    percent: 80,
  },
];

export const inputGraphs = [
  'Syrup', 'Water', 'CO2', 'CO2', 'Perform'
];

export const totalizerValues = [
  {
    head: "Totalizer Values",
  },
  {
    text: "Water Totalizer",
    value: "10,567 Liters",
  },
  {
    text: "Syrup Totalizer",
    value: "2,567 Liters",
  },
  {
    text: "CO2 Totalizer",
    value: "113 KG",
  },
];

export const addtionalParameters = [
  {
    head: "Additional Paramerters",
  },
  {
    text: "Brix in product",
    value: "10.5 Bx",
  },
  {
    text: "Volume of CO2 in Product",
    value: "4.4 vol",
  },
];

export const dashboardTabs = [
  { name: "KPIs Dashboard", id: 1 },
  { name: "KPIs Dashboard Full Day", id: 2 },
];

export const pepsiTypes = {
  '345ml': pepsi,
  '500ml': pepsi,
  '1000ml': pepsi2,
  '2250ml': pepsi2,
  '1500ml': pepsi2
}

export const productionCounter = [
  {
    text1: "Production Unit:",
    value1: "345 ml",
    text2: "Units Produced:",
    value2: "3,014 Phc",
    img: pepsi,
  },
  {
    text1: "Production Unit:",
    value1: "345 ml",
    text2: "Units Produced:",
    value2: "3,014 Phc",
    img: pepsi2,
  },
  {
    text1: "Production Unit:",
    value1: "345 ml",
    text2: "Units Produced:",
    value2: "3,014 Phc",
    img: pepsi2,
  },
];

export const chartTabs = [
  { name: "All Machines", id: 1 },
  { name: "Machine Name", id: 2 },
  { name: "Machine Name", id: 3 },
  { name: "Machine Name", id: 4 },
  { name: "Machine Name", id: 5 },
  { name: "Machine Name", id: 6 },
  { name: "Machine Name", id: 7 },
];

export const accordianHead = (
  <div className="dflex accordianHeadCont">
    <img src={alert} />
    <div className="accordianHead">
      <h1>Line 3 is down</h1>
      <p>9/27/22 | 12:37pm</p>
    </div>
  </div>
);

export const alertData = [
  { head: accordianHead, text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. ", key: 1 },
  { head: accordianHead, text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. ", key: 2 },
  { head: accordianHead, text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. ", key: 3 },
  { head: accordianHead, text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. ", key: 4 },
  { head: accordianHead, text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. ", key: 5 },
  { head: accordianHead, text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. ", key: 6 },
  { head: accordianHead, text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. ", key: 7 },
]

export const sidebarTabs = [
  { head: "Dashboards", key: "1", Icon: PieChartOutlined, link: pageRoutes.dashboard },
  { head: "Line Operator", key: "2", Icon: DesktopOutlined, link: pageRoutes.lineOperator },
  // { head: "Plant Averages View", key: "3", Icon: ContainerOutlined, link: "" },
  { head: "Line Settings", key: "5", Icon: ContainerOutlined, link: "" },
  { head: "Plant Settings", key: "6", Icon: ContainerOutlined, link: "" },
  { head: "Integrations", key: "7", Icon: ContainerOutlined, link: "" },
  { head: "Line Board", key: "8", Icon: ContainerOutlined, link: "" },
  { head: "Audit Trails", key: "9", Icon: ContainerOutlined, link: "" },
  { head: "Line Perf Monitor", key: "11", Icon: ContainerOutlined, link: "" },
];
//table-role
export const Tablerole = [
  {
    title: 'Role Name',
    dataIndex: 'roleName',
    key: 'roleName',
    // render: (text) => <a>{text}</a>,
  },
  {
    title: 'Capabilities',
    key: 'capabilities',
    dataIndex: 'capabilities',
    render: (_, { capabilities }) => (
      <>
        {capabilities?.map((capability) => {
          let color = '#E7ECF1'
          return (
            <Tag style={{ borderRadius: "20px " }} color={color} key={capability}>
              <p style={{ color: "black" }}>{capability.toUpperCase()}</p>
            </Tag>
          );
        })}
      </>
    ),
  },
  {
    title: 'Rights',
    dataIndex: 'rights',
    key: 'rights',
    // render: (text) => <a>{text}</a>,
  },
  {
    title: 'Actions',
    key: 'action',
    align: 'right',
    render: () => <img src={edit} style={{ width: "20px", cursor: "pointer", marginRight: "20px" }} />
  },
];

export const TableDataRole = [
  {
    key: '1',
    roleName: 'John Brown',
    rights: 'Edit only',
    capabilities: ['nice', 'developer', 'cool', 'teacher', 'cool', 'teacher'],
  },
  {
    key: '2',
    roleName: 'Jim Green',
    rights: 'Edit only',
    capabilities: ['loser', 'cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher'],
  },
  {
    key: '3',
    roleName: 'Joe Black',
    rights: 'Edit only',
    capabilities: ['cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher'],
  },
  {
    key: '3',
    roleName: 'Joe Black',
    rights: 'Edit only',
    capabilities: ['cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher'],
  },
  {
    key: '3',
    roleName: 'Joe Black',
    rights: 'Edit only',
    capabilities: ['cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher'],
  },
  {
    key: '3',
    roleName: 'Joe Black',
    rights: 'Edit only',
    capabilities: ['cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher', 'cool', 'teacher'],
  },

];
//table-user
export const Tableuser = [
  {
    title: 'EmailAddress',
    dataIndex: 'EmailAddress',
    key: 'EmailAddress',
    // render: (text) => <a>{text}</a>,
  },
  {
    title: 'Role',
    dataIndex: 'Role',
    key: 'Role',
  },
  {
    title: 'Line',
    dataIndex: 'Line',
    key: 'Line',
  },

  {
    title: 'Actions',
    key: 'action',
    align: 'right',
    render: () =>
      <>
        <img src={edit} style={{ width: "20px", cursor: "pointer", marginRight: "20px" }} />
        <img src={trash} style={{ width: "20px", cursor: "pointer" }} />
      </>
  },
];

// export const Tableuserdata = [
//   {
//     key: '1',
//     EmailAddress: 'John Brown',
//     Role: 32,
//     Line: 'line 1',

//   },
//   {
//     key: '2',
//     EmailAddress: 'John Brown',
//     Role: 32,
//     Line: 'line 2',

//   },
//   {
//     key: '3',
//     EmailAddress: 'John Brown',
//     Role: 32,
//     Line: 'line 3',

//   },
//   {
//     key: '4',
//     EmailAddress: 'John Brown',
//     Role: 32,
//     Line: 'line 3',

//   },
//   {
//     key: '5',
//     EmailAddress: 'John Brown',
//     Role: 32,
//     Line: 'line 3',

//   },
//   {
//     key: '6',
//     EmailAddress: 'John Brown',
//     Role: 32,
//     Line: 'line 3',

//   },
// ];
// Table 

export const LineOpColumns = [
  {
    title: "#",
    dataIndex: "index"
  },
  {
    title: "Date",
    dataIndex: "date",
  },
  {
    title: 'Time',
    dataIndex: 'time',
  },
  {
    title: 'Detected Issues',
    dataIndex: 'detecIssues',
  },
  {
    title: "Reason",
    dataIndex: 'reason',
  },
  {
    title: "",
    dataIndex: "edit",
    render: () => <><img src={edit} style={{ width: "20px", cursor: "pointer" }} /></>
  }
];

export const lineOperatorOptions = [
  {
    title: "#",
    dataIndex: "key"
  },
  {
    title: "Date",
    dataIndex: "startedAt",
    render: (date) => moment(date).format('YYYY-MM-DD')
  },
  {
    title: 'Time',
    dataIndex: 'started',
  },
  // {
  //   title: 'Detected Issues',
  //   dataIndex: 'comment',
  // },
]

export const LineOpData = [];
for (let i = 1; i <= 10; i++) {
  LineOpData.push({
    key: i,
    index: Number(`${i}`),
    date: "18 Jul 2022",
    time: '12:56:13',
    detecIssues: "Circuit failure",
    ...(i % 2 === 0 ? { reason: "Some idiot spilled water on the main board" } : { reason: 'button' }),
  });
};


export const SiteChampionFormLabels = [
  { label: "name", title: "Name", placeholder: "Abdullah Ghaus", id: 1, isRequired: true, isType: "text" },
  { label: "email", title: "Email Address", placeholder: "richardwilliams@email.com", id: 2, isRequired: true, isType: "email" },
  { label: "url", title: "Ticket Url", placeholder: "www.url.com", id: 3, isRequired: true, isType: "text" },
];
export const APIParameters = [
  { title: "code", data: "(string: API Key)", id: 1 },
  {
    title: "date",
    data: "(string: ISO 8601 date format, starting date from where to collect historic data)",
    id: 2,
  },
  {
    title: "days",
    data: "(number: Number of days from starting date for which data should be collected)",
    id: 3,
  },
  { title: "lineId", data: "(string: target production line id)", id: 4 },
  { title: "machine", data: "(string: target machine id)", id: 5 },
];
export const APIEndPoints = [
  {
    title: "API KEY",
    data: "eK/0q1eKmpdlBvazzNuud3x9s8kYz8vh32BEdKwWauEMqQMk9Gvs/A==",
    id: 1,
  },
  {
    title: "DOWNTIME LOGS REPORT API",
    data: `${azureFunctionsURL}/getDowntimeLogsReport?code=eK/0q1eKmpdlBvazzNuud3x9s8kYz8vh32BEdKwWauEMqQMk9Gvs/A==`,
    id: 2,
  },
  {
    title: "STATS REPORT API",
    data: `${azureFunctionsURL}/getStatsReport?code=eK/0q1eKmpdlBvazzNuud3x9s8kYz8vh32BEdKwWauEMqQMk9Gvs/A==`,
    id: 3,
  },
];

export const drawerLineOPData = [
  { serial: "18 Jul 2022" },
  { time: "18 Jul 2022" },
  { date: "18 Jul 2022" },
  { detectedIssue: "18 Jul 2022" }
]

export const categoryData1 = [
  { head: "Category" },
  { text: 'Some Data', key: 1 },
  { text: 'Some Data', key: 2 },
  { text: 'Some Data', key: 3 },
  { text: 'Some Data', key: 4 },
  { text: 'Some Data', key: 5 },
  { text: 'Some Data', key: 6 },
  { text: 'Some Data', key: 7 },
]

export const categoryData2 = [
  { head: "Sub Category" },
  { text: 'Some Data' },
  { text: 'Some Data' },
  { text: 'Some Data' },
  { text: 'Some Data' },
  { text: 'Some Data' },
  { text: 'Some Data' },
]

export const categoryData3 = [
  { head: "Reason" },
  { text: 'Some Data' },
  { text: 'Some Data' },
  { text: 'Some Data' },
  { text: 'Some Data' },
  { text: 'Some Data' },
  { text: 'Some Data' },
]

const tags = {
  'disconnectTime': <Tag color='red'>Currently Disconnected</Tag>,
  'disconnectTimeEnded': <Tag color="orange">Disconnected</Tag>,
  'downtimeEnded': <Tag color="orange">Disconnected</Tag>,
  // 'downTime': <Tag color="gold">DownTime</Tag>
}

export const LineOpDrawerData = {};
export const DownTimeLogOps = [
  // {
  //   title: "Type",
  //   dataIndex: "type",
  //   render: (keyRec, rec) => (
  //     tags[keyRec] || <Tag color="blue">No Reason Given</Tag>
  //   )
  // },
  {
    title: "Reasons",
    dataIndex: "reason",
    editable: true,
    render: (text, record) =>
    <Popover content={record.type != 'disconnectLog'?`Type "planned downtime" in comment if you want to reverse impact the OEE`:''} showArrow={record.type != 'disconnectLog'? true : false}>
          (text ? (
            <b><span style={{ opacity: 0.8 ,fontWeight:'bolder' }}>{''}</span>{text}</b>
          ) : !record.ended ? (
            <Tag color="red"><span style={{ opacity: 0.8 ,fontWeight:'bolder' }}>{''}</span>{`Current ${record.type.substring(0, record.type.length - 3)}`}</Tag>
          ) : (record.type === 'disconnectLog')  ? (
            <Tag color="orange">Disconnect {record.systemReason?('- '+record.systemReason):''}</Tag>
          ) : (
            <span style={{ opacity: 0.5}}><span style={{ opacity: 0.8 ,fontWeight:'bolder' }}>{''}</span>- No reason given -</span>
          ))</Popover>,
          render: (text, record) => {
            return (
              <Popover content={record.type != 'disconnectLog'?`Type "planned downtime" in comment if you want to reverse impact the OEE`:''} showArrow={record.type != 'disconnectLog'? true : false}>
              <span>
                {text && <b><span style={{ opacity: 0.8 ,fontWeight:'bolder' }}>{''}</span>{text} </b>}
                {!record.ended ? (
                  <Tag color="red"><span style={{ opacity: 0.8 ,fontWeight:'bolder' }}>{''}</span>{`Current ${record.type.substring(
                    0,
                    record.type.length - 3
                  )}`}</Tag>
                ) : (record.type === 'disconnectLog') ? (
                  <Tag color="orange" style={{fontWeight:'bolder'}}>Disconnect {record.systemReason?('- '+record.systemReason):''}</Tag>
                ) : !text ? (
                  <span style={{ opacity: 0.5 }}><span style={{ opacity: 0.8 ,fontWeight:'bolder' }}>{''}</span>- No reason given -</span>
                ) : null}
              </span>
              </Popover>
            );
          },

  },
  {
    title: "Started at",
    dataIndex: "started",
  },
  {
    title: "Duration",
    dataIndex: "duration",
    render: (data, record) => (
      data === "Still Running" ? <Timer date={record?.startedAt} /> : data
    )
  },
  {
    title: 'Comment',
    dataIndex: 'comment',
    editable: true,
    render: (text, record) => {
      if(record.type!='disconnectLog')
        return (
          <Popover content="Type 'planned downtime' if you want to reverse impact the OEE">
          <div style={{ color: text.toLowerCase() === 'planned downtime' ? '#1EA849' : 'inherit', fontWeight: text.toLowerCase() === 'planned downtime' ? 'bold' : 'normal' }}>
            {text}
          </div>
        </Popover>
        
        
        );
      
      return text;
    },
  },
  {
    title: "History",
    dataIndex: "history",
    render: (data, record) => (
      <Popover
        content={
          data?.length ?
            <div className="historyPopover">
              {[...data].reverse().map((item, index, arr) => (
                <div key={index} className="historyBox">
                  {index === 0 ? (
                    <div>
                      <span style={{ fontWeight: 'bold' }}>Updated At:</span> {moment(item?.createdAt).format('MMMM Do YYYY, hh:mm:ss A')}<br />
                      <span style={{ fontWeight: 'bold' }}>By:</span> {item?.userEmail}<br />
                      {item?.comment && <><span style={{ fontWeight: 'bold' }}>Comment:</span> {item.comment}<br /></>}
                      {item?.reason && <><span style={{ fontWeight: 'bold' }}>Reason:</span> {item.reason}<br /></>}
                    </div>
                  ) : (
                    <>
                      {index === 1 && (
                        <h4 style={{ marginTop: index === 0 ? 0 : 8, fontWeight: 'bold' }}>Other Updates</h4>
                      )}
                      <div className={index > 0 ? 'greyText' : ''}>
                        <span style={{ fontWeight: 'bold' }}>Updated At:</span> {moment(item?.createdAt).format('MMMM Do YYYY, hh:mm:ss A')}<br />
                        <span style={{ fontWeight: 'bold' }}>By:</span> {item?.userEmail}<br />
                        {item?.comment && <><span style={{ fontWeight: 'bold' }}>Comment:</span> {item.comment}<br /></>}
                        {item?.reason && <><span style={{ fontWeight: 'bold' }}>Reason:</span> {item.reason}<br /></>}
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
            :
            <NoDataFound />
        }
      >
        <img src={history} style={{ cursor: 'pointer' }} />
      </Popover>
    )
  },
];
export const DownTimeOpData = [];

for (let i = 1; i <= 10; i++) {
  DownTimeOpData.push({
    key: i.toString(),
    reasons: "name@procheck.pk",
    startedAt: "15:01:06",
    duration: "15:01:06",
    comment: "",
    history: <img src={profile} alt="profile" />,
  });
}



export const PlantAlertTableData = [];
for (let i = 0; i <= 10; i++) {
  PlantAlertTableData.push({
    emailaddress: "name@procheck.pk",
    ...(i % 2 === 0 ? { role: "admin" } : { role: "operator" }),
    line: "Line 3",
    actions: <div className='textRight dflex alignCenter justifyFE gap10'><img src={edit} className="cursorPointer" /> <img src={trash} className="cursorPointer" /></div>
  });
}

// Tabs Data

export const plantSettingsTabs = [
  { key: 'user', text: "Users", id: 1 },
  { key: 'roles', text: "Roles", id: 2 },
  { key: 'alerts', text: "Alerts", id: 3 },
  { key: 'champion', text: "Site Champion", id: 4 },
];

export const LineSettingsTabs = [
  { key: 'lineInfo', text: "Line Information", id: 1 },
  { key: 'shifts', text: "Shifts", id: 2 },
  { key: 'plannedDowntime', text: "Planned Downtime", id: 3 },
  { key: 'products', text: "Products", id: 4 },
  { key: 'weeklySchedule', text: "Weekly Schedule", id: 5 },
  { key: 'downtime', text: "Downtime", id: 6 },
  { key: 'dailyTargets', text: "Daily Targets", id: 7 },
  { key: 'formulaCreation', text: "Formula Creation", id: 8 },
  { key: 'manual', text: "Manual Entry", id: 9 },
  { key: 'weeklyTargets', text: "Weekly Targets", id: 10 },

]

// Pages Map

export const plantSettingsMap = {
  user: <CustomUserTable />,
  alerts: <PlantSettingsAlert />,
  champion: <PlantSiteChampion />,
  roles: <PlantsettingRole />
}

export const lineSettingsMap = {
  lineInfo: <LineInformation />,
  shifts: <LineSettingsShift />,
  plannedDowntime: <PlannedDowntime />,
  products: <LineSettingsProduct />,
  weeklySchedule: <WeeklySchedule />,
  downtime: <Downtime />,
  dailyTargets: <DailyTargets />,
  formulaCreation: <FormulaCreation />,
  manual: <ManualEntry />,
  weeklyTargets: <WeeklyTargets />
}

export const LineInformationPoints = [
  {
    title: "ID",
    data: "eK/0q1eKmpdlBvazzNuud3x9s8kYz8vh32BEdKwWauEMqQMk9Gvs/A==",
    id: 1,
  },
  {
    title: "SENSORY ENTRY ENDPOINT",
    data: `${azureFunctionsURL}/getDowntimeLogsReport?code=eK/0q1eKmpdlBvazzNuud3x9s8kYz8vh32BEdKwWauEMqQMk9Gvs/A==`,
    id: 2,
  },
  {
    title: "PRIMARY KEY",
    data: `${azureFunctionsURL}/getStatsReport?code=eK/0q1eKmpdlBvazzNuud3x9s8kYz8vh32BEdKwWauEMqQMk9Gvs/A==`,
    id: 3,
  },
];

export const DowntimeFormLabels = [
  { label: "calculation", title: "STOP TIME FOR DOWNTIME CALCULATION", id: 1, isType: "number", text: "It represents the stoppages greater than this number of mins to be added to the downtime." },
  { label: "reason", title: "STOP TIME FOR REASON MARKING", id: 2, isType: "number", text: "It represents the visibility of downtime on the line operator screen which are greater than the following minutes." },
  { label: "disconnect", title: "STOP TIME FOR DISCONNECT CHECKER", id: 3, isType: "number", text: "It represents the number of minutes after which the line would be shown as disconnected." },
];


export const priviligedLines = ['liquid-line-5_lt0ru', 'cac-line-1_vhb0l', 'cac-line-2_iednb', 'fette-3rd_39hxg', 'semi-solids_sqotl', 'qalsium-line_d726e', 'noack-manual_8aygb', 'cam-blister-l_r5w12', 'mf-line_bx6wt', 'dhP7vfkzqQKoqAAgHjN9', 'line-1_tex7q', 'mespack-line_6ufjm', 'mespack-line_lnbne', 'mespack-line_8024u', 'mespack-line_1u2gm','treet-razor_srjdm'];
export const colors = [
  '#48C66F',
  // 'rgb(30, 168, 73)',
  'blue',
  '#006400',
  '#8A2BE2',
  'gray',
  '#D2691E',
  '#00008B',
  '#DC143C',
  '008B8B'
]
export const StrokeColorsChart = {
  Filler: '#7FFF00',
  BlowMold: '#006400',
  Preform: '#8A2BE2',
  Labeller: '#00FFFF',
  Palletizer: '#D2691E',
  Variopac: '#00008B',
  Filler: '#DC143C',
}

// '008B8B'

//Table Columns 

export const RejectionModalTableColumns = [
  {
    title: "Time",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (createdAt) => moment(createdAt).format('H:mm:ss')
  },
  {
    title: "User",
    dataIndex: "userEmail",
    key: "user",
  },
  {
    title: "Value",
    dataIndex: "value",
    key: "value",
  },
  {
    title: "Ratio",
    dataIndex: "primary",
    key: "ratio",
    render: (primary, record) => primary ? primary : 1
  },
];



// OEE

export const homeCards = [
  { name: "cartoner", type: 2, percent: 31, plant: "oee" },
  { name: "cartoner", type: 1, percent: 31, plant: "oee" },
  { name: "cartoner", type: 3, percent: 31, plant: "oee" },
  { name: "cartoner", type: 2, percent: 31, plant: "oee" },
  { name: "cartoner", type: 1, percent: 31, plant: "oee" },
  { name: "cartoner", type: 1, percent: 31, plant: "oee" },
  { name: "cartoner", type: 3, percent: 31, plant: "oee" },
  { name: "cartoner", type: 2, percent: 31, plant: "oee" },
  { name: "cartoner", type: 1, percent: 31, plant: "oee" },
  { name: "cartoner", type: 3, percent: 31, plant: "oee" },
  { name: "cartoner", type: 2, percent: 31, plant: "oee" },
  { name: "cartoner", type: 2, percent: 31, plant: "oee" },
  { name: "cartoner", type: 2, percent: 31, plant: "oee" },
  { name: "cartoner", type: 1, percent: 31, plant: "oee" },
  { name: "cartoner", type: 1, percent: 31, plant: "oee" },
  { name: "cartoner", type: 3, percent: 31, plant: "oee" },
  { name: "cartoner", type: 1, percent: 31, plant: "oee" },
  { name: "cartoner", type: 1, percent: 31, plant: "oee" },
  { name: "cartoner", type: 2, percent: 31, plant: "oee" },
  { name: "cartoner", type: 1, percent: 31, plant: "oee" },
  { name: "cartoner", type: 1, percent: 31, plant: "oee" },
]


export const oee_dashboard_tabs = [
  { name: "Dashboard", id: 1 },
  // { name: "Plant Averages View", id: 2 },
];

export const oee_dashboard_stats = [
  { speed: 0, batch_no: "XXXXXXXX", current: { name: "Chewcal Tablets", time: "8:00AM" }, previous: { name: "Movital Tablets", time: "6:00AM - 8:00AM" } }
]

export const oee_dashboard_output = [
  { name: 'Group A', value: 4567, color: "#1E6EFE" },
  { name: 'Group B', value: 2400, color: "#EB5757" },
];

export const oee_dashboard_shiftTime = [
  { name: 'Group A', value: 3000, color: "#1E6EFE" },
  { name: 'Group B', value: 3000, color: "#EB5757" },
  { name: 'Group C', value: 3000, color: "#1EA849" },
];

export const auditTrailsTableDes = {
  rows: [
    {
      key: 1,
      Action: 'Report ID',
      Plant: 'Plant A',
    },
    {
      key: 2,
      Action: 'Downtime',
      Plant: 'Plant A',
    },
    {
      key: 3,
      Action: 'Product',
      Plant: 'Report ID',
    },
    {
      key: 4,
      Action: 'Planned Downtime',
      Plant: 'Plant A',
    },
    {
      key: 5,
      Action: 'Line ID',
      Plant: 'Plant A',
    },
  ],
  columns: [
    {
      title: 'Action',
      dataIndex: 'Action',
      key: 'Action',
    },
    {
      title: 'Plant',
      dataIndex: 'Plant',
      key: 'Plant',
    },

  ]
}

export const auditTrailTable = {
  rows: [
    {
      key: 1,
      action: 'action 1',
      plantName: 'plantName A',
      hallName: 'hallName 1',
      lineName: 'lineName 1',
      machine: 'machine 1',
      User: 'User 1',
      Shift: 'shift 1',
      Date: '2/5/15:12:56:13',
      description: <div className='DescriptionCard'> <AuditTrailTableDes /></div>,

    },
    {
      key: 2,
      action: 'action 1',
      plantName: 'plantName A',
      hallName: 'hallName 1',
      lineName: 'lineName 1',
      machine: 'machine 1',
      User: 'User 1',
      Shift: 'shift 1',
      Date: '2/5/15:12:56:13',
      description: <div className='DescriptionCard'> <AuditTrailTableDes /></div>,

    },
    {
      key: 3,
      action: 'action 1',
      plantName: 'plantName A',
      hallName: 'hallName 1',
      lineName: 'lineName 1',
      machine: 'machine 1',
      User: 'User 1',
      Shift: 'shift 1',
      Date: '2/5/15:12:56:13',
      description: <div className='DescriptionCard'> <AuditTrailTableDes /></div>,

    },
    {
      key: 4,
      action: 'action 1',
      plantName: 'plantName A',
      hallName: 'hallName 1',
      lineName: 'lineName 1',
      machine: 'machine 1',
      User: 'User 1',
      Shift: 'shift 1',
      Date: '2/5/15:12:56:13',
      description: <div className='DescriptionCard'> <AuditTrailTableDes /></div>,

    },
    {
      key: 5,
      action: 'action 1',
      plantName: 'Plant A',
      hallName: 'hallName 1',
      lineName: 'lineName 1',
      machine: 'machine 1',
      User: 'User 1',
      Shift: 'shift 1',
      Date: '2/5/15:12:56:13',
      description: <div className='DescriptionCard'> <AuditTrailTableDes /></div>,

    },
  ],
  column: [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
    },
    {
      title: 'Plant',
      dataIndex: 'plantName',
      key: 'plantName',
    },
    {
      title: 'Hall',
      dataIndex: 'hallName',
      key: 'hallName',
    },
    {
      title: 'Line',
      dataIndex: 'lineName',
      key: 'lineName',
    },
    {
      title: 'Machine',
      dataIndex: 'machine',
      key: 'machine',
      render: (value) => value || 'N/A'
    },
    {
      title: 'User',
      dataIndex: 'userId',
      key: 'userId',
    },
    {
      title: 'Shift',
      dataIndex: 'shiftName',
      key: 'shiftName',
      render: (value) => value || 'N/A'
    },
    {
      title: 'Date/Time',
      dataIndex: 'time',
      key: 'time',
      render: (value) => moment(value).format('DD/MM/YY HH:mm:ss')
    },


  ]
}


export const reasons = [
  { id: 1, name: 'All Reasons' },
  { id: 2, name: 'Add Role' },
  { id: 3, name: 'Alert Created' },
  { id: 4, name: 'Alert Deleted' },
  { id: 5, name: 'Alert Updated' },
  { id: 6, name: 'Batch Change Over' },
  { id: 7, name: 'Change Over' },
  { id: 8, name: 'Daily Targets Added' },
  { id: 9, name: 'Daily Targets Sync' },
  { id: 10, name: 'Daily Targets Updated' },
  { id: 11, name: 'Daily target Added' },
  { id: 12, name: 'Weekly Targets Added' },
  { id: 13, name: 'Weekly Targets Sync' },
  { id: 14, name: 'Weekly Targets Updated' },
  { id: 15, name: 'Delete Role' },
  { id: 16, name: 'Headcount Added' },
  { id: 17, name: 'Headcount Updated' },
  { id: 18, name: 'Line Setting Updated' },
  { id: 19, name: 'Manual Shift Added' },
  { id: 20, name: 'Planned Downtime Added' },
  { id: 21, name: 'Planned Downtime Deleted' },
  { id: 22, name: 'Planned Downtime Updated' },
  { id: 23, name: 'Planned Stoppage Added' },
  { id: 24, name: 'Planned Stoppage Deleted' },
  { id: 25, name: 'Planned Stoppage Updated' },
  { id: 26, name: 'Product Created' },
  { id: 27, name: 'Product Deleted' },
  { id: 28, name: 'Product Updated' },
  { id: 29, name: 'Production Line Update' },
  { id: 30, name: 'Rejection Deleted' },
  { id: 31, name: 'Rework Added' },
  { id: 32, name: 'Rework Deleted' },
  { id: 33, name: 'Shift Added' },
  { id: 34, name: 'Shift Deleted' },
  { id: 35, name: 'Shift Force Stopped' },
  { id: 36, name: 'Shift Updated' },
  { id: 37, name: 'Site Champions Added' },
  { id: 38, name: 'Stop Time Added' },
  { id: 39, name: 'Stop Time Updated' },
  { id: 40, name: 'Update Role' },
  { id: 41, name: 'Weekly Schedule Sync' },
  { id: 42, name: 'Weekly Schedule Updated' },
  { id: 43, name: 'Downtime Report' },
  { id: 44, name: 'OEE Report' },
  { id: 45, name: 'Weekly Target Update' },
]

export const testFunc = () => {
  let target = 247
  let total = 100
  let ratio = total / target;
  let temp = 0
  let prevRatio = 0
  // console.log({ initialRatio: ratio })
  Array(target)
    .fill('_')
    .forEach((item, i) => {
      // console.log(, i + 1);
    })
  // console.log(ratio * target)
}


export const access_capabilities = {
  view_all: 'view-all',
  view_home: 'view-home',
  view_dashboard: 'view-dashboard',
  view_machine_dashboard: 'view-machine-dashboard',
  view_lineOperator: 'view-observer',
  view_downtimeLog: 'view-downtimeLog',
  view_lineSettings: 'view-line-settings',
  view_lineLevelBoard: 'view-line-level-board',
  view_plantSettings: 'view-plant-settings',
  view_integrationDetails: 'view-integration-details',
  canEndShiftEarly: 'end-shift',
  canWriteProduct: 'product-write-access',
  canEditLineSettings: 'edit-line-settings',
  hasMachineAccess: 'machine-access',
  canDoManualEntry: 'manual-entry',
  canUpdateDowntime: 'update-downtimeLog',
  hasAuditTrailAccess: 'audit-trail-access',
  canCreateRework: 'create-dynamicAdjustments-rework',
  canCreateRejections: 'create-dynamicAdjustments-add-rejections',
  view_lineBoard: 'view-leaderboard',
  canUpdateRoles: 'update-roles',
  hasPLantRoleAccess: 'plant-role-access',

}

export const sidebarKeys = {
  '0': { icon: <img className="sidebarMenuIcon" src={homepage} />, route: pageRoutes.oee.homepage },
  '1': { icon: <img className="sidebarMenuIcon" src={dashboardic} />, route: pageRoutes.dashboard },
  '2': { icon: <img className="sidebarMenuIcon" src={documenttext} />, route: pageRoutes.oee.linePerformanceMonitor },
  '3': { icon: <img className="sidebarMenuIcon" src={lineBoard} />, route: pageRoutes.LineLevelBoard },
  // '11': { icon: <img className="sidebarMenuIcon" src={dashboardic} />, route: pageRoutes.machineDashboard },
  '4': { icon: <img className="sidebarMenuIcon" src={lineBoard} />, route: pageRoutes.lineBoard },
  '5': { icon: <img className="sidebarMenuIcon" src={lineopic} />, route: pageRoutes.lineOperator },
  // '6': { icon: <img className="sidebarMenuIcon" src={tasksquare} />, route: pageRoutes.plantAveragesView },
  // '7': { icon: <img className="sidebarMenuIcon" src={setting} />, route: pageRoutes.maintanenceKpis },
  '6': { icon: <img className="sidebarMenuIcon" src={trenddown} />, route: pageRoutes.downtimeLog },
  '7': { icon: <img className="sidebarMenuIcon" src={linesetting} />, route: pageRoutes.lineSettings },
  '8': { icon: <img className="sidebarMenuIcon" src={plantsetting} />, route: pageRoutes.plantSettings },
  '9': { icon: <img className="sidebarMenuIcon" src={integration} />, route: pageRoutes.integrations },
  '10': { icon: <img className="sidebarMenuIcon" src={documenttext} />, route: pageRoutes.AuditTrail },
}

export const getIcons = (items = []) => {
  let menu = items?.map((item) => ({ ...item, icon: sidebarKeys[item.key].icon }))
  return menu
}

export const pageIds = {
  home: 'view-home',
  dashboard: 'view-dashboard',
  // machineDashboard: 'view-machine-dashboard',
  plantAveragesView: 'all',
  linePerfMonitor: 'view-line-perf-monitor',
  lineLevelBoard: 'view-line-level-board',
  lineBoard: 'view-leaderboard',
  lineOperator: 'view-observer',
  maintanenceKpis: 'all',
  downtimeLog: 'view-downtimeLog',
  lineSettings: 'view-line-settings',
  plantSettings: 'view-plant-settings',
  integrations: 'view-integration-details',
  auditTrails: 'audit-trail-access',
}
